import { connect } from 'react-redux';
import ProfileSettings from 'components/SettingsModal/ProfileSettings';
import { FLAG_ENABLE_PROFILE_EDIT, FLAG_ENABLE_PROFILE_PICTURE } from 'constants/FeatureFlags';
import { SubmissionError } from 'redux-form';
import settingsActions from 'actions/SettingsModal';
import {
  contactActions as nucleusContactActions,
  nucleusConstants,
  currentUserSelectors,
  pstnNumbersSelectors,
  featureSelectors
} from '@lifesize/nucleus';
import { getInviteForExtension } from 'actions/Invite';
import _get from 'lodash/get';

const mapStateToProps = (state) => {
  const pstnNumbers = pstnNumbersSelectors.pstnNumbersWithCountryName(state);

  return {
    userProfile: currentUserSelectors.myInfo(state),
    passwordLink: _get(state, 'nucleus.provisioning.changePasswordURL'),
    initialValues: currentUserSelectors.myInfo(state),
    isEditingProfileName: _get(state, 'app.settingsModal.isEditingProfileName'),
    isSSO: _get(state, 'nucleus.sso.loginSupportType') === nucleusConstants.LOGIN_SUPPORT_TYPE_SSO,
    extension: _get(state, 'nucleus.userProfile.extension'),
    profileEditEnabled: featureSelectors.getFeatureFlag(state)(FLAG_ENABLE_PROFILE_EDIT),
    profilePictureEnabled: featureSelectors.getFeatureFlag(state)(FLAG_ENABLE_PROFILE_PICTURE),
    pstnNumbers,
    shouldShowPstnNumbers: !!_get(pstnNumbers, 'length')
  };
};

function mapDispatchToProps(dispatch) {
  return {
    saveContact: (contactObj) =>
      new Promise((resolve, reject) => {
        const contact = Object.assign({}, contactObj);
        if (!contact.sipUri) {
          contact.sipUri = contactObj.video;
        }
        if (!contact.contactType) {
          contact.contactType = nucleusConstants.CONTACT_TYPE_STANDARD;
        }
        Promise.resolve(dispatch(nucleusContactActions.validateContact(contact)))
          .then(() => {
            dispatch(nucleusContactActions.saveContact(contact)).then(() => {
              resolve();
            });
          })
          .catch((error) => {
            const errorObj = {};
            errorObj[error[0].context.key] = `${error[0].context.value} already exists`;
            /* eslint-disable no-underscore-dangle */
            errorObj._error = 'Creating a contact failed';
            /* eslint-enable no-underscore-dangle */
            reject(new SubmissionError(errorObj));
          });
      }),
    toggleEditName: (isEditing) => {
      dispatch(settingsActions.toggleEditName(isEditing));
    },
    getInviteForExtension: async (extension) => dispatch(getInviteForExtension(extension))
  };
}

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
  ...stateProps,
  ...dispatchProps,
  ...ownProps,
  getInviteForExtension: async () => dispatchProps.getInviteForExtension(_get(stateProps, 'initialValues.dialString'))
});

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(ProfileSettings);
